import { State } from 'models';

export const currentCooperativeSelector = (state: State) =>
  state.settings.current_cooperative;
